import { useEffect } from "react";
import { faqs } from "./data";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import FocusTopics from "./components/FocusTopics";
import FeatureReads from "./components/FeatureReads";
import TimelineSection from "./components/TimelineSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

const faqJsonLd = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

function ScrollTop() {
  useEffect(() => {
    const el = document.getElementById("back-top");
    const onScroll = () => {
      if (el) el.style.display = window.scrollY > 700 ? "flex" : "none";
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      id="back-top"
      href="#top"
      className="hidden fixed right-5 bottom-6 z-40 w-11 h-11 items-center justify-center rounded-full bg-foreground-900 text-background-50 shadow hover:bg-primary-600 transition"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </a>
  );
}

export default function Home() {
  return (
    <main className="bg-background-50 text-foreground-950">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqJsonLd }} />

      <Header />
      <Hero />
      <HotList />
      <FocusTopics />
      <FeatureReads />
      <TimelineSection />
      <GuideSection />
      <FaqSection />
      <AboutSection />
      <ContactSection />
      <Footer />
      <ScrollTop />
    </main>
  );
}